/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionPaymentInfoOffer
 */
export interface SubscriptionPaymentInfoOffer {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentInfoOffer
     */
    offerId: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentInfoOffer
     */
    trialDays: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentInfoOffer
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentInfoOffer
     */
    credits: number;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionPaymentInfoOffer
     */
    validUntil?: Date;
}

/**
 * Check if a given object implements the SubscriptionPaymentInfoOffer interface.
 */
export function instanceOfSubscriptionPaymentInfoOffer(value: object): value is SubscriptionPaymentInfoOffer {
    if (!('offerId' in value) || value['offerId'] === undefined) return false;
    if (!('trialDays' in value) || value['trialDays'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('credits' in value) || value['credits'] === undefined) return false;
    return true;
}

export function SubscriptionPaymentInfoOfferFromJSON(json: any): SubscriptionPaymentInfoOffer {
    return SubscriptionPaymentInfoOfferFromJSONTyped(json, false);
}

export function SubscriptionPaymentInfoOfferFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionPaymentInfoOffer {
    if (json == null) {
        return json;
    }
    return {
        
        'offerId': json['offerId'],
        'trialDays': json['trialDays'],
        'price': json['price'],
        'credits': json['credits'],
        'validUntil': json['validUntil'] == null ? undefined : (new Date(json['validUntil'])),
    };
}

export function SubscriptionPaymentInfoOfferToJSON(json: any): SubscriptionPaymentInfoOffer {
    return SubscriptionPaymentInfoOfferToJSONTyped(json, false);
}

export function SubscriptionPaymentInfoOfferToJSONTyped(value?: SubscriptionPaymentInfoOffer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'offerId': value['offerId'],
        'trialDays': value['trialDays'],
        'price': value['price'],
        'credits': value['credits'],
        'validUntil': value['validUntil'] == null ? undefined : ((value['validUntil']).toISOString()),
    };
}

